module.exports = __webpack_public_path__ + "img/logo.19a08358.png";